import React from 'react';
// @ts-ignore
import styles from './HealthPlanBabyEducationMaterialsCustomHeader.module.scss';

const HealthPlanBabyEducationMaterialsCustomHeader: React.FC = () => (
	<div className={styles.wrapper}>
		<div>
			<img
				src='https://cdn.meddi.com/assets/education-materials/health-plan/baby/latam/common/unicef-logotype-latam.png'
				alt='Unicef logotype latam'
			/>
		</div>
		<div>
			MEDDI Baby cuenta con material educativo de autoría de UNICEF y bajo su
			autorización es puesto a disposiciónpara educar a las mujeres en cuidados
			sobre su gestación y la primera infancia.
		</div>
	</div>
);

export default HealthPlanBabyEducationMaterialsCustomHeader;
